export default "__VITE_ASSET__BBn5v1Ay__"